import templateUrl from 'emun.customer/customer-vendor-information.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import CustomerVendorPrompt from "emun.customer/customer-vendor/customer-vendor";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class CustomerVendorInformationController {
  constructor($rootScope) {
    const $ctrl = this;
    $ctrl.bus = new ServiceBus();
    basicController($ctrl);
    $ctrl.load();
  }

  load() {
    if (this.customer) {
      this.vendorInfo = new AutoQuery({
        url: 'QueryRetailerVendors?retailerId=' + this.customer.id,
        orderBy: '-VendorId',
        autoLoad: true,
        pageSize: 50
      })

      this.locationInfo = new AutoQuery({
        url: 'QueryRetailerVendorLocations?retailerId=' + this.customer.id,
        orderBy: '-VendorId',
        autoLoad: true,
        pageSize: 50
      })
    }
  }

  addNew(customer, type, saveType) {
    var request = {
      VendorId: "",
      RetailerId: customer.id,
      SalesRepId: "",
      PaymentTerms: "",
      RepGroupId: "",
      VendorCustId: "",
      VendorShipId: ""
    };
    return CustomerVendorPrompt({
      customer,
      request,
      type,
      saveType
    }).then(() => this.load());
  }

  edit(customer, request, type, saveType) {
    return CustomerVendorPrompt({
      customer,
      request,
      type,
      saveType
    }).then(() => this.load());
  }

  delete(request, type) {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Record")
      .result.then(function () {
        if (type == "Customer") {
          $ctrl.bus
            .send("DeleteRetailerVendor.json", { retailerId: request.retailerId, vendorId: request.vendorId })
            .then(
              function (response) {
                $ctrl.load();
              },
              function (response) {
                if (response.data.responseStatus.errorCode)
                  modals.alert(response.data.responseStatus.message);
              }
            );
        } else if (type == "Location") {
          $ctrl.bus
            .send("DeleteRetailerVendorLocation.json", { retailerId: request.retailerId, shipId: request.shipId, vendorId: request.vendorId })
            .then(
              function (response) {
                $ctrl.load();
              },
              function (response) {
                if (response.data.responseStatus.errorCode)
                  modals.alert(response.data.responseStatus.message);
              }
            );
        }

      });
  }
}

let CustomerVendorInformation = {
  bindings: {
    customer: '<'
  },
  controller: CustomerVendorInformationController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default CustomerVendorInformation